module.exports = __webpack_public_path__ + "img/culture_04.2355aa21.png";